import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'fr': {
        TEST_SELFMAP: 'Testez SelfMap!',
        //inside map
        DATA_FROM_SEARCH: 'Saisir ici...',
        SEARCH_ADRESS: 'Rechercher une adresse',
        LOCATE_ME: 'Localiser moi',
        DATA_SEARCH: 'Recherche de données',
        LABEL_IS: 'Libellé: ',
        DETAIL_INFORMATION: 'Informations Détaillées:',
        CLOSE_DETAILS: 'Fermer la fenêtre détails',
        ALERT_WARNING: 'Problème lors de l\'affichage de votre carte, veuillez vérifier si votre serveur est démarré, et que votre application est bien configurée. Si vous avez toujours des difficultés, veuillez contactez votre administrateur'
    },
    'en': {
        TEST_SELFMAP: 'Try SelfMap!',
        //insode map
        DATA_FROM_SEARCH: 'Data from search field...',
        SEARCH_ADRESS: 'Search an adress',
        LOCATE_ME: 'Locate me',
        DATA_SEARCH: 'Data search',
        LABEL_IS: 'Label: ',
        DETAIL_INFORMATION: 'Details:',
        CLOSE_DETAILS: 'Close details panel',
        ALERT_WARNING: `Problem while displaying your map, please check if your server is launched, your application is correctly configured. If you are still having difficulties, please contact your administrator`
    }
};

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'fr', // set fallback locale
    messages, // set locale messages
});

export default i18n;